import Vue from 'vue';
import DealDetail from './DealDetail.vue';

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(DealDetail),
}).$mount('#vue-deal-detail');
